export enum CallsOverviewTableColumns {
    CALL_ID = 'callId',
    START_TIME = 'startTime',
    CALLER = 'caller',
    CUSTOMER_NAME = 'customerName',
    COMPANY_NAME = 'companyName',
    DIRECTION = 'direction',
    CALL_STATUS = 'callStatus',
    CALL_QUEUE = 'callQueue',
    HUNTED_AGENT = 'huntedAgent',
    CALLEE = 'callee',
    WAITING_DURATION = 'waitingDuration',
    TALKING_DURATION = 'talkingDuration',
    CALL_DURATION = 'callDuration',
    RECIPIENT = 'recipient',
    PARTICIPANTS = 'participants',
    VOICEMAIL = 'voicemail',
    VOICEMAIL_DURATION = 'voicemailDuration'
}